import { IdName } from 'interfaces/IdName';
import { isUndefined } from 'lodash';

export const includesAmenity = (
  amenity: string,
  amenities?: IdName[],
): boolean =>
  !isUndefined(amenities) &&
  amenities?.some(a => a.name?.toLowerCase() === amenity.toLowerCase());
